import { CheckOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Empty, Skeleton, Tag, Tooltip } from "antd";
import moment from "moment";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  useGetQuotationOrNpdQuery,
  useGetSalesAfterNpdQuotationQuery,
  useGetSalesAfterQuotationQuery,
} from "../../services/api";
import { Text } from "../CommonFont/text";
import { ActionDropdown } from "../InventoryOptions";
import "./index.css";
interface ITableForm {
  data?: any;
  headingData: any;
  setOpen?: (data: boolean) => void;
  setId?: (data: any) => void;
  dataById?: any;
  loading: boolean;
  selectedValue?: string;
  setOpenDrawer?: (data: boolean) => void;
  setDrawerContent?: (data: any) => void;
}
interface ReportItem {
  order_no?: string;
  executive_name?: string;
  lead_name?: string;
  company_name?: string;
  enquiry_category?: string;
  advance_received_amount?: number;
  order_date?: string | Date;
  order_status_display?: "Dispatch Added" | "Pending" | "Completed" | "Cancelled" | string;
}
interface ReportsDescriptionProps {
  keys: number;
  item: ReportItem;
}
export const TableCard: React.FC<ITableForm> = ({
  data,
  headingData,
  setOpen,
  setId,
  dataById,
  selectedValue,
  loading,
  setOpenDrawer,
  setDrawerContent,
}) => {
  const navigate = useNavigate();
  const currentUrl = useLocation().pathname;
  const userRole = localStorage.getItem("user_role");

  const getOrderStatusColor = (status?: string): string => {
    switch (status) {
      case "Dispatch Added":
        return "green";
      case "Pending":
        return "orange";
      case "Completed":
        return "blue";
      case "Cancelled":
        return "red";
      case "In Progress":
        return "lime";
      case "Delivered":
        return "cyan";
      default:
        return "default";
    }
  };

  const isQuotationActive = (
    isClosed: boolean | number | string,
  ) =>
    isClosed === false ||
    isClosed === "false" ||
    isClosed === 0 ||
    isClosed === "0";

  const Specification = ({ item, recordIndex }: any) => {
    const [showAll, setShowAll] = useState(false); // State to track whether to show all items
    const [selectedDimensions, setSelectedDimensions] = useState<
      Record<number, string>
    >({});
    const handleRowClick = (record: any) => {
      // Set selected warehouse details
      setDrawerContent && setDrawerContent("preview"); // Open the drawer in preview mode
      setOpen?.(true);
    };
    const specifications = Array.isArray(item?.specification)
      ? item?.specification
      : [];

    // Limit the displayed specifications based on `showAll`
    const displayedSpecifications = showAll
      ? specifications
      : specifications.slice(0, 2);

    return (
      <div
        className={
          specifications.length > 0
            ? "flex flex-col spec-width2"
            : "flex flex-col "
        }
      >
        {specifications.length > 0 ? (
          <>
            {displayedSpecifications?.map((spec: any, specIndex: number) => {
              const specKey: any = `${recordIndex}-${specIndex}`;
              return (
                <div key={specKey} className="flex flex-col mb-2">
                  {/* Display selected dimension */}
                  <div className="flex gap-2">
                    {selectedDimensions[specKey] ? (
                      <div style={{ marginBottom: "5px" }}>
                        <span>Dimension:</span>{" "}
                        <strong>{selectedDimensions[specKey]}</strong>
                      </div>
                    ) : (
                      <div style={{ marginBottom: "5px" }}>
                        <span>Dimension:</span>{" "}
                        {spec?.valueFields
                          ?.flatMap((item: any) => item?.dimension_value) // Flatten all dimension_value arrays
                          ?.map(
                            (
                              dimension: any,
                              index: number,
                              array: string[]
                            ) => (
                              <strong key={index}>
                                {dimension}
                                {index !== array.length - 1 && ", "}
                              </strong>
                            )
                          )}
                      </div>
                    )}

                    {spec.unitOptions?.length > 0 && (
                      <strong>
                        {}
                        {
                          spec.unitOptions.find(
                            (option: any) =>
                              option.value === spec.valueFields[0]?.unit
                          )?.label
                        }
                      </strong>
                    )}
                  </div>
                  {/* Specification Name */}
                  <div className="flex">
                    <div>Specification Name:</div>
                    <strong className="pl-5"> {spec.specification_name}</strong>
                  </div>
                </div>
              );
            })}

            {/* Show View All button if there are more than 2 items */}
            {!showAll && specifications.length > 2 && (
              <div
                onClick={() => {
                  navigate(
                    `/finished-goods?id=${item?.id}&type=${selectedValue}`
                  );
                  handleRowClick(item);
                }}
                className="mt-2 text-blue-500 hover:underline view-all cursor-pointer"
              >
                View All
              </div>
            )}
          </>
        ) : (
          <div>-</div>
        )}
      </div>
    );
  };
  const FinishedGoods = ({ keys, item }: any) => {
    return (
      <div>
        {keys === 0 && (
          <div>
            <div>{item?.finished_goods_id || "-"}</div>
          </div>
        )}

        {keys === 1 && (
          <div>
            <div>{item?.name?.name || "-"}</div>
          </div>
        )}

        {keys === 2 && (
          <div>
            <div>{item?.category?.name?.name || "-"}</div>
          </div>
        )}

        {keys === 3 && (
          <div>
            <div>{item?.brand?.name || "-"}</div>
          </div>
        )}

        {keys === 4 && (
          <div>
            <div>{item?.model?.name || "-"}</div>
          </div>
        )}

        {keys === 5 && (
          <div className={item?.specification?.length > 0 ? "spec-width" : ""}>
            <Specification item={item} recordIndex={keys} />
          </div>
        )}

        {keys === 6 && (
          <div>
            <div>{item?.grade?.name || "-"}</div>
          </div>
        )}

        {keys === 7 && (
          <div>
            <div>{item?.color?.name || "-"}</div>
          </div>
        )}

        {keys === 8 && (
          <div>
            <div>{item?.stock_quantity || "-"}</div>
          </div>
        )}

        {keys === 9 && (
          <div>
            <div>{item?.safety_stock || "-"}</div>
          </div>
        )}

        {keys === 10 && (
          <div>
            <div>{item?.demand_forcast || "-"}</div>
          </div>
        )}

        {keys === 11 && (
          <div>
            <div>{item?.lead_time || "-"}</div>
          </div>
        )}

        {keys === 12 && (
          <div>
            <div>{item?.new_order_demand || "-"}</div>
          </div>
        )}

        {keys === 13 && (
          <div>
            <div>{item?.stock_required || "-"}</div>
          </div>
        )}

        {keys === 14 && (
          <div>
            <div>
              {item?.modified_date
                ? moment(item.modified_date).format("DD/MM/YYYY")
                : "-"}
            </div>
          </div>
        )}

        {keys === 15 && (
          <div>
            <div>{item?.dead_stock || "-"}</div>
          </div>
        )}

        {keys === 16 && (
          <div>
            <div>{item?.reservations || "-"}</div>
          </div>
        )}

        {keys === 17 && (
          <div>
            <div>
              {item?.is_active === false ? (
                <Tag color="red" icon={<CloseCircleOutlined />}>
                  Inactive
                </Tag>
              ) : (
                <Tag color="green" icon={<CheckOutlined />}>
                  Active
                </Tag>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };
  const Description = ({ keys, item }: any) => {
    return (
      <div>
        <div>{keys === 0 && item?.company_name}</div>
        <div>{keys === 1 && item?.region_name}</div>
        <div>{keys === 2 && item?.phone}</div>
        <div>{keys === 3 && item?.email}</div>
        <div>{keys === 4 && item?.type_name}</div>
        <div>{keys === 5 && item?.industry_name}</div>
      </div>
    );
  };

  const AllocatedDescription = ({ keys, item }: any) => {
    return (
      <div>
        <div>{keys === 0 && item?.sales_lead_id}</div>
        <div>{keys === 1 && item?.company_name}</div>
        <div>{keys === 2 && item?.region_name}</div>
        <div>{keys === 3 && item?.phone}</div>
        <div>{keys === 4 && item?.email}</div>
        <div>{keys === 5 && item?.type_name}</div>
        <div>{keys === 6 && item?.industry_name}</div>
        <div>{keys === 7 && item?.enquiry_category_name}</div>
        <div>
          {keys === 8 &&
            (userRole === "1"
              ? item?.allocated_to_name
              : item?.allocated_by_name)}
        </div>

        <div>
          {keys === 9 &&
            (item?.status?.title_name === "Follow Up 1" ? (
              <Tag color="cyan">Follow up 1</Tag>
            ) : item?.status?.title_name === "Follow Up 2" ? (
              <Tag color="orange">Follow up 2</Tag>
            ) : item?.status?.title_name === "Follow Up 3" ? (
              <Tag color="purple">Follow up 3</Tag>
            ) : (
              "-"
            ))}
        </div>
        {/* <div>{keys === 9 && item?.status}</div> */}
      </div>
    );
  };
  const EmployeeDetailsDescription = ({ keys, item }: any) => {
    return (
      <div>
        <div>{keys === 0 && item?.sales_lead_id}</div>
        <div>{keys === 1 && item?.company_name}</div>
        <div>{keys === 2 && item?.region_name}</div>
        <div>{keys === 3 && item?.phone}</div>
        <div>{keys === 4 && item?.email}</div>
        <div>{keys === 5 && item?.type_name}</div>
        <div>{keys === 6 && item?.industry_name}</div>
        {/* <div>{keys === 7 && item?.enquiry_category_name}</div> */}
        {/* <div>
          {keys === 7 &&
            (userRole === "1"
              ? item?.allocated_to_name
              : item?.allocated_by_name)}
        </div> */}

        <div>
          {keys === 7 &&
            (item?.status?.title_name === "Follow Up 1" ? (
              <Tag color="cyan">Follow up 1</Tag>
            ) : item?.status?.title_name === "Follow Up 2" ? (
              <Tag color="orange">Follow up 2</Tag>
            ) : item?.status?.title_name === "Follow Up 3" ? (
              <Tag color="purple">Follow up 3</Tag>
            ) : (
              "-"
            ))}
        </div>
        {/* <div>{keys === 9 && item?.status}</div> */}
      </div>
    );
  };
  const Companyname = ({ id, npd_id }: any) => {
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(id);

    const { data: npdData, isLoading: loadingNpdQuery } =
      useGetSalesAfterNpdQuotationQuery(npd_id);
    return (
      <>
        <div>
          {quotationData?.data[0]?.company_name
            ? quotationData?.data[0]?.company_name
            : npdData?.data[0]?.company_name
            ? npdData?.data[0]?.company_name
            : "-"}
        </div>
      </>
    );
  };
  const LeadName = ({ id, npd_id }: any) => {
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(id);

    const { data: npdData, isLoading: loadingNpdQuery } =
      useGetSalesAfterNpdQuotationQuery(npd_id);
    return (
      <>
        <div>
          {" "}
          {quotationData?.data[0]?.lead_name
            ? quotationData?.data[0]?.lead_name
            : npdData?.data[0]?.lead_name
            ? npdData?.data[0]?.lead_name
            : "-"}
        </div>
      </>
    );
  };
  const EnquiryName = ({ id, npd_id }: any) => {
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(id);
    const { data: npdData, isLoading: loadingNpdQuery } =
      useGetSalesAfterNpdQuotationQuery(npd_id);
    return (
      <>
        <div>
          {" "}
          {quotationData?.data[0]?.enquiry_category_name
            ? quotationData?.data[0]?.enquiry_category_name
            : npdData?.data[0]?.enquiry_category_name
            ? npdData?.data[0]?.enquiry_category_name
            : "-"}
        </div>
      </>
    );
  };
  const Code = ({ id, npd_id }: any) => {
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(id);
    const { data: npdData, isLoading: loadingNpdQuery } =
      useGetSalesAfterNpdQuotationQuery(npd_id);
    return (
      <>
        <div>
          {" "}
          {quotationData?.data[0]?.sales_lead_id
            ? quotationData?.data[0]?.sales_lead_id
            : npdData?.data[0]?.sales_lead_id
            ? npdData?.data[0]?.sales_lead_id
            : "-"}
        </div>
      </>
    );
  };
  const OrderCompanyname = ({ id }: any) => {
    const { data: npdOrQuotationData, isLoading: npdOrQuotationDataLoading } =
      useGetQuotationOrNpdQuery(id);
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(npdOrQuotationData?.data[0]?.sales_lead);
    const { data: npdData, isLoading } = useGetSalesAfterNpdQuotationQuery(
      npdOrQuotationData?.data[0]?.npd
    );

    return (
      <>
        <div>
          {quotationData?.data[0]?.company_name
            ? quotationData?.data[0]?.company_name
            : npdData?.data[0]?.company_name}
        </div>
      </>
    );
  };
  const OrderLeadName = ({ id }: any) => {
    const { data: npdOrQuotationData, isLoading: npdOrQuotationDataLoading } =
      useGetQuotationOrNpdQuery(id);
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(npdOrQuotationData?.data[0]?.sales_lead);
    const { data: npdData, isLoading } = useGetSalesAfterNpdQuotationQuery(
      npdOrQuotationData?.data[0]?.npd
    );
    return (
      <>
        <div>
          {quotationData?.data[0]?.lead_name
            ? quotationData?.data[0]?.lead_name
            : npdData?.data[0]?.lead_name}
        </div>
      </>
    );
  };
  const OrderCode = ({ id }: any) => {
    const { data: npdOrQuotationData, isLoading: npdOrQuotationDataLoading } =
      useGetQuotationOrNpdQuery(id);
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(npdOrQuotationData?.data[0]?.sales_lead);
    const { data: npdData, isLoading } = useGetSalesAfterNpdQuotationQuery(
      npdOrQuotationData?.data[0]?.npd
    );

    return (
      <>
        <div>
          {" "}
          {quotationData?.data[0]?.sales_lead_id
            ? quotationData?.data[0]?.sales_lead_id
            : npdData?.data[0]?.code
            ? npdData?.data[0]?.code
            : "-"}
        </div>
      </>
    );
  };
  const CUINo = ({ id }: any) => {
    const { data: quotationData, isLoading: loadingQuery } =
      useGetSalesAfterQuotationQuery(id);

    // useEffect(() => {
    //   if (id) {
    //     trigger(id);
    //   }
    // }, [id]);

    return (
      <>
        <div>
          {" "}
          {quotationData?.data[0]
            ?.contacts_customer_unique_identification_number
            ? quotationData?.data[0]
                ?.contacts_customer_unique_identification_number
            : "-"}
        </div>
      </>
    );
  };
  const QuoatationDescription = ({ keys, item }: any) => {
    return (
      <div>
        <div>{keys === 0 && item?.date}</div>
        <div>{keys === 1 && <CUINo id={item?.sales_lead} />}</div>
        <div>
          {keys === 2 && <Code id={item?.sales_lead} npd_id={item?.npd} />}
        </div>
        <div>
          {keys === 3 && <LeadName id={item?.sales_lead} npd_id={item?.npd} />}
        </div>
        <div>
          {keys === 4 && (
            <Companyname id={item?.sales_lead} npd_id={item?.npd} />
          )}
        </div>
        <div>
          {keys === 5 && (
            <EnquiryName id={item?.sales_lead} npd_id={item?.npd} />
          )}
        </div>
        <div>{keys === 6 && "-"}</div>
        <div>
          {keys === 7 && (
            <Tag
              color={isQuotationActive(item?.is_closed) ? "green" : "red"}
            >
              {isQuotationActive(item?.is_closed) ? "Active" : "Closed"}
            </Tag>
          )}
        </div>
      </div>
    );
  };
  const SalesDescription = ({ keys, item }: any) => {
    return (
      <div>
        <div>{keys === 0 && item?.sales_lead_id}</div>
        <div>
          {keys === 1 && (
            <Tooltip title={item?.lead_name}>
              {item?.lead_name?.length > 10
                ? item?.lead_name?.slice(0, 8).concat("...")
                : item?.lead_name}
            </Tooltip>
          )}
        </div>
        <div>{keys === 2 && item?.region_name} </div>
        <div>{keys === 3 && item?.phone}</div>
        <div>{keys === 4 && item?.email}</div>
        <div>{keys === 5 && item?.type_name}</div>
        <div>{keys === 6 && item?.industry_name}</div>
        <div>{keys === 7 && "-"}</div>
      </div>
    );
  };
  const NpdDescription = ({ keys, item }: any) => {
    return (
      <div>
        <div>{keys === 0 && item?.code}</div>
        <div>{keys === 1 && item?.client_name}</div>
        <div>{keys === 2 && item?.product_name} </div>
        <div>{keys === 3 && item?.specification}</div>
        <div>{keys === 4 && item?.quantity}</div>
        <div>{keys === 5 && item?.group_name}</div>
        <div>{keys === 6 && item?.phone}</div>
      </div>
    );
  };
  const OrderDescription = ({ keys, item }: any) => {
    return (
      <div>
        <div>
          {keys === 0 && moment(item?.created_date).format("DD-MM-YYYY")}
        </div>
        <div>{keys === 1 && item?.order_no}</div>
        <div>{keys === 2 && <OrderCode id={item?.quotation} />} </div>
        <div>{keys === 3 && <OrderCompanyname id={item?.quotation} />}</div>
        <div>{keys === 4 && <OrderLeadName id={item?.quotation} />}</div>
        <div>
          {keys === 5 &&
            (item?.advance_received_amount
              ? item?.advance_received_amount
              : "-")}
        </div>
        <div>
          {keys === 6 &&
            (item?.order_status === 3 ? (
              <Tag color={"green"}>Completed</Tag>
            ) : item?.order_status === 2 ? (
              <Tag color={"purple"}>Delivered</Tag>
            ) : item?.order_status === 1 ? (
              <Tag color={"magenta"}>Open</Tag>
            ) : (
              <Tag color={"lime"}>In Progress</Tag>
            ))}
        </div>
      </div>
    );
  };
  const ReportsDescription: React.FC<ReportsDescriptionProps> = ({ keys, item }) => {
    return (
      <div>
        <div>{keys === 0 && item?.order_no}</div>
        <div>{keys === 1 && item?.executive_name}</div>
        <div>{keys === 2 && item?.lead_name}</div>
        <div>{keys === 3 && item?.company_name}</div>
        <div>{keys === 4 && item?.enquiry_category}</div>
        <div>
          {keys === 5 &&
            (item?.advance_received_amount
              ? `₹${item.advance_received_amount.toLocaleString()}`
              : "-")}
        </div>
        <div>
          {keys === 6 &&
            (item?.order_date
              ? moment(item.order_date).format("DD-MM-YYYY")
              : "-")}
        </div>
        <div>
          {keys === 7 && (
            <Tag color={getOrderStatusColor(item?.order_status_display)}>
              {item?.order_status_display || "-"}
            </Tag>
          )}
        </div>
      </div>
    );
  };
  return (
    <>
      {loading ? (
        <Skeleton
          paragraph={{ rows: 8, width: "100%" }}
          className="resp-table-card "
        />
      ) : data?.length > 0 ? (
        data?.map((items: any, indexs: number) => (
          <div className="margin">
            <div
              className="resp-table-card "
              onClick={(e) => {
                setOpen?.(true);
                setId && setId(items?.id);
                currentUrl !== "/finished-goods" &&
                  navigate(`${currentUrl}?id=${items?.id}`);
              }}
            >
              {currentUrl === "/finished-goods" &&
                (localStorage.getItem("user_role") === "2" ||
                  localStorage.getItem("user_role") === "1") && (
                  <div className="flex justify-end">
                    <ActionDropdown
                      record={items}
                      selectedValue={selectedValue as string}
                      setOpen={setOpenDrawer && (setOpenDrawer as any)}
                      setDrawerContent={
                        setDrawerContent && (setDrawerContent as any)
                      }
                    />
                  </div>
                )}
              {headingData?.map((item: any, index: number) => (
                <div
                  key={index}
                  className="flex justify-between w-full table-card-main-div"
                >
                  <div>
                    <Text variant="wearlay-paragraph-bold" value={item} />
                  </div>
                  <div>
                    {currentUrl === "/quotation" ? (
                      <QuoatationDescription
                        item={items}
                        key={index}
                        keys={index}
                      />
                    ) : currentUrl === "/finished-goods" ? (
                      <FinishedGoods item={items} key={index} keys={index} />
                    ) : currentUrl === "/sales" ? (
                      <SalesDescription item={items} key={index} keys={index} />
                    ) : currentUrl === "/inquiries" ? (
                      <NpdDescription item={items} key={index} keys={index} />
                    ) : currentUrl === "/order" ? (
                      <OrderDescription item={items} key={index} keys={index} />
                    ) : currentUrl === "/allocated" ? (
                      <AllocatedDescription
                        item={items}
                        key={index}
                        keys={index}
                      />
                    ) : currentUrl === "/employee-detail-page" ? (
                      <EmployeeDetailsDescription
                        item={items}
                        key={index}
                        keys={index}
                      />
                    ) : currentUrl === "/reports" ? (  // Add this condition for Reports
                      <ReportsDescription item={items} key={index} keys={index} />
                    ) : (
                      <Description item={items} key={index} keys={index} />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))
      ) : (
        <div className="no-data-card resp-table-card">
          <Empty />
        </div>
      )}
    </>
  );
};
